export default __webpack_public_path__ + "static/media/specialist@3x.c86ce73a.png";